import "@hotwired/turbo"
import "./controllers/index"
import "preline"

function initPreline() {
  if (window.HSStaticMethods) {
    window.HSStaticMethods.cleanCollection()
    window.HSStaticMethods.autoInit()
  }
}

function closeDashboardDropdowns() {
  document.querySelectorAll(".hs-dropdown").forEach((dropdown) => {
    dropdown.classList.remove("hs-dropdown-open")
    dropdown.querySelectorAll(".hs-dropdown-menu").forEach((menu) => {
      menu.classList.add("hidden", "opacity-0")
      menu.classList.remove("opacity-100")
      menu.removeAttribute("style")
    })
    dropdown.querySelectorAll(".hs-dropdown-toggle").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false")
    })
  })
}

document.addEventListener("turbo:load", initPreline)
document.addEventListener("DOMContentLoaded", initPreline)
document.addEventListener("turbo:before-cache", closeDashboardDropdowns)
document.addEventListener("turbo:before-visit", closeDashboardDropdowns)
